// extracted by mini-css-extract-plugin
module.exports = {"itemTitle":"PhoneSetting_itemTitle__2dwXB"};